import { z } from 'zod/v4';

// Format schema used across all visualizations
export const FormatFieldSchema = z.string().default('');

// Color properties pattern
export const ColorPropertiesSchema = z.object({
    hasPositiveColor: z.boolean().default(false),
    hasNegativeColor: z.boolean().default(false),
});

// Row index with validation
export const RowIndexFieldSchema = z.number().min(0).default(0).brand<'RowIndexReference'>();

// Create a branded type for column references
export const ColumnReferenceSchema = z.string().brand<'ColumnReference'>();
